module.exports = __webpack_public_path__ + "static/media/velocity-frame-1.e247f52a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/screens/highDefinitionOptics/VelocityTest/velocity-frame-1.jpg
// module id = 3612
// module chunks = 0